/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_USER_ROLES: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.govj.switchRoles',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_USER_ROLES' },
      },
    },
    GET_USER_ROLES: {
      invoke: {
        id: 'getUserRoles',
        src: 'getUserRoles',
        onDone: {
          target: 'GET_USER_ROLES_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_USER_ROLES_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    GET_USER_ROLES_SUCCESS: {
      on: {
        GET_ACCESS_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
        },
      },
    },
    GET_USER_ROLES_FAILED: {
      on: {
        START: { target: 'GET_USER_ROLES' },
      },
    },
    GET_ACCESS_TOKEN: {
      invoke: {
        id: 'getAccessToken',
        src: 'getAccessToken',
        onDone: {
          target: 'SIGN_IN_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SIGN_IN_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SIGN_IN_USER_SUCCESS: {
      on: {
        START: { target: 'GET_USER_ROLES' },
      },
    },
    SIGN_IN_USER_FAILED: {
      on: {
        START: {
          target: 'GET_USER_ROLES',
        },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
